export type Breakpoints = {isMobile: boolean; isTablet: boolean; isWide: boolean};

export const useBreakpointsHelper = (): Breakpoints => {
    const breakpoints = {mobile: 991, tablet: 1200, wide: 1920};

    const isMobileWindow = window.innerWidth <= breakpoints.mobile;
    const isTabletWindow = window.innerWidth <= breakpoints.tablet;
    const isWideWindow = window.innerWidth > breakpoints.wide;

    return {
        isWide: isWideWindow,
        isTablet: isTabletWindow,
        isMobile: isMobileWindow,
    };
};
